<div class="d-flex p-0 m-0 mt-2 align-items-center justify-content-center">
    <button
        class="btn btn-sm rounded-pill mx-1 {{ pagination.from === null || pagination.current_page === 1 ? 'd-none' : 'btn-outline-secondary' }}"
        (click)="paginationClick(navigateTo.FIRST)"
        [disabled]="pagination.from === null || pagination.current_page === 1"><i class="bi bi-chevron-double-left"></i>
    </button>
    <button
        class="btn btn-sm rounded-pill mx-1 {{ pagination.from === null || pagination.current_page === 1 ? 'd-none' : 'btn-outline-secondary' }}"
        (click)="paginationClick(navigateTo.PREVIOUS)"
        [disabled]="pagination.from === null || pagination.current_page === 1"><i
            class="bi bi-chevron-compact-left"></i>
    </button>
    <div class="mx-2">
        <p class="py-1 m-0 small text-center border-bottom">
            Page {{ pagination.current_page }} of {{ pagination.last_page}}
        </p>
        <p class="py-1 m-0 small text-center">
            Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} record(s)
        </p>
    </div>
    <button
        class="btn btn-sm rounded-pill mx-1 {{ pagination.to === null || pagination.current_page === pagination.last_page ? 'd-none' : 'btn-outline-secondary' }}"
        (click)="paginationClick(navigateTo.NEXT)"
        [disabled]="pagination.to === null || pagination.current_page === pagination.last_page"><i
            class="bi bi-chevron-compact-right"></i>
    </button>
    <button
        class="btn btn-sm rounded-pill mx-1 {{ pagination.to === null || pagination.current_page === pagination.last_page ? 'd-none' : 'btn-outline-secondary' }}"
        (click)="paginationClick(navigateTo.LAST)"
        [disabled]="pagination.to === null || pagination.current_page === pagination.last_page"><i
            class="bi bi-chevron-double-right"></i>
    </button>
</div>